import {
	type CollectibleAuctionFront,
	type CollectibleBidFront,
	type CollectibleCollectibleFront,
	type CollectibleEventListRefined,
	type CollectibleParticipantRefined
} from '@capsicum/common';

export const auctionsUtils = () => {
	const getHomeTeam = (event: CollectibleEventListRefined) => {
		return event?.teamEvents?.find(team => team.qualifier === 'home')?.team?.name;
	};

	const getAwayTeam = (event: CollectibleEventListRefined) => {
		return event?.teamEvents?.find(team => team.qualifier === 'away')?.team?.name;
	};

	return { getAwayTeam, getHomeTeam };
};

export const parseAuctionFront = (auction: CollectibleAuctionFront) => {
	// Re-assign externalImages to providerImages to match existing hook
	const collectible = auction.collectible as CollectibleCollectibleFront;

	// Re-assign chilizUserId to participant.chilizUserId to match existing hook
	const currentBid = auction.currentBid as CollectibleBidFront & {
		participant: CollectibleParticipantRefined;
	};

	if (currentBid) {
		currentBid.participant = {};
		currentBid.participant.chilizUserId = auction?.currentBid?.chilizUserId;
	}

	// Re-assign isVisible flag for tags. From this endpoint it's always true
	const tags = collectible.tags as Array<{ isVisible: boolean }>;

	if (tags) {
		tags.forEach(tag => {
			tag.isVisible = true;
		});
	}

	if (collectible.collectibleAttributes?.length) {
		const attributes = collectible.collectibleAttributes as Array<{
			attribute: {
				isVisible: boolean;
			};
		}>;

		// Re-assign isVisible flag for attributes. From this endpoint it's always true
		attributes?.forEach(attr => {
			attr.attribute.isVisible = true;
		});
	}
};
